import React, { memo } from 'react';

import { MainFilters } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters';

export const FiltersWrapper = memo(() => {
    return <MainFilters />;
});
